import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import BasicField from './fields/basic'
import PasswordField from './fields/password'
import AccountField from './fields/account'

const ENTER_KEY = 13

const FIELDS = {
  'reset-email': () => new AccountField({ placeholder: 'Email', type: 'email', requiresAccount: true }),
  'account-exist': () => new AccountField({ placeholder: 'Email or username', requiresAccount: true }),
  'account-new': () => new AccountField({ placeholder: 'Email', type: 'email', requiresAccount: false, autocomplete: 'off' }),
  password: () => new PasswordField(),
  'password-exist': () => new PasswordField({ current: true, autofocus: true }),
  'first-name': () => new BasicField({ placeholder: 'First name', name: 'first-name', required: true }),
  'last-name': () => new BasicField({ placeholder: 'Last name', name: 'last-name', required: true }),
  'multi-step-login-check': (opts = {}) => {
    _.defaults(opts, {
      placeholder: 'Email or username',
      name: 'username',
      required: true,
      minLength: 3,
      pattern: '.{3,255}',
      autocorrect: 'off',
      autocapitalize: 'none',
      autocomplete: 'username',
      spellcheck: false
    })

    return new BasicField(opts)
  },
  'multi-step-login-authenticate-username': (opts = {}) => {
    _.defaults(opts, {
      placeholder: 'Email or username',
      name: 'username',
      required: true,
      readonly: true
    })

    return new BasicField(opts)
  }
}

export default class Form extends Backbone.View {
  get events () {
    return {
      'keydown input' (e) {
        if (e.which === ENTER_KEY && this.state.get('submittable')) {
          e.preventDefault()
          this.trigger('submit')
        }
      }
    }
  }

  initialize (opts) {
    this.state = opts.state
    this.fields = {}
    opts.fields.forEach((name) => {
      const field = FIELDS[name]({ value: this.state.get('username') })
      this.listenTo(field, 'state', obj => this.state.set(obj))
      this.listenTo(field, 'error', (...args) => this.trigger('error', ...args))
      this.listenTo(field, 'view:action', (...args) => this.trigger('view:action', ...args))
      const fieldName = field.name || field.$input.prop('name')
      this.fields[fieldName] = field
    })
  }

  render () {
    this.$el.append(_.map(this.fields, f => f.render().$el))
    return this
  }

  serialize () {
    return _.mapObject(this.fields, f => f.$input.val())
  }

  focusInvalid () {
    this.$('input[aria-invalid="true"]').first().focus()
  }

  validate () {
    return _.reduce(this.fields, (formValid, f) => f.validate() && formValid, true)
  }

  toggleError (name, error) {
    this.fields[name].toggleError(error)
  }

  remove () {
    _.invoke(this.fields, 'remove')
    super.remove()
  }
}
